import { render, staticRenderFns } from "./GatherResult.vue?vue&type=template&id=999aab3a&scoped=true&"
import script from "./GatherResult.vue?vue&type=script&lang=js&"
export * from "./GatherResult.vue?vue&type=script&lang=js&"
import style0 from "./GatherResult.vue?vue&type=style&index=0&id=999aab3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999aab3a",
  null
  
)

export default component.exports